var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWebDesign = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.305,
    height: 601.119,
    viewBox: "0 0 800.305 601.119",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-582 -270.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.178,20.347C49.587,40.079,69.3,1.923,20.825,96.319L0,82.4,43.132,0S58.91,18.665,58.178,20.347Z",
    transform: "translate(881.237 684.615) rotate(-60)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.33,62.709S-3.4,65.041.675,51.054L8.834,23.082S-1.655-5.473,14.662.938,41.468,46.975,41.468,46.975s6.994,30.3,0,30.3-29.138,4.656-26.806,0S12.33,62.709,12.33,62.709Z",
    transform: "matrix(-0.139, 0.99, -0.99, -0.139, 1027.148, 715.997)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.075,331.538C483.9,350.318,502.66,314,456.524,403.845L436.7,390.6l41.053-78.425S492.772,329.937,492.075,331.538Z",
    transform: "translate(374.43 392.782)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.394,525c0-5.677-1.906-10.284-4.247-10.294h-638.1c-2.351.011-4.247,4.618-4.258,10.294V758.689a2.121,2.121,0,0,1-1.916,2.112q-2.568.247-5.138.459c-.042,0-.085.011-.127.011-.932.085-1.864.148-2.8.222H282.8q-.719-1.33-1.422-2.682a2.131,2.131,0,0,1-.241-.984V511.649c0-1.568.064-3.146.169-4.7a60.246,60.246,0,0,1,.794-6.376c1.79-9.839,5.836-16.5,10.432-16.522H939.649a4.96,4.96,0,0,1,1.949.413,7.6,7.6,0,0,1,2.4,1.684,14.9,14.9,0,0,1,2.362,3.23c2.266,3.993,3.887,9.945,4.459,16.872,0,.064.011.127.011.191.148,1.716.222,3.463.212,5.211l.148,22.7.1,13.535.286,42.47.106,15.082.466,154.841h0a2.118,2.118,0,0,1-2.118,2.118h-8.515a2.118,2.118,0,0,1-2.118-2.118Z",
    transform: "translate(363.495 107.901)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.984,383.772H674.227a3.669,3.669,0,0,0-3.663,3.672V496.06h76.092V387.445a3.671,3.671,0,0,0-3.672-3.672Zm-34.147,61.714a8.157,8.157,0,0,1-8.119-8.119V424.84a8.119,8.119,0,1,1,16.238,0v12.528a8.157,8.157,0,0,1-8.119,8.119Z",
    transform: "translate(386.513 101.974)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.341,486.513v10.479a2.053,2.053,0,0,0,2.049,2.049h72.467a2.059,2.059,0,0,0,2.049-2.049V486.513Z",
    transform: "translate(386.5 108.047)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.689,242.088a14.663,14.663,0,0,1-21.349,7.051l-97.054,67.612-2.68-26.944,95.427-61.826a14.742,14.742,0,0,1,25.656,14.108Z",
    transform: "translate(374.813 92.401)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.944,283.481s-10.509,15.528,5.982,29.27,83.331,11.008,94.118,10.89,60.277-51.314,60.277-51.314L542,242.758l-59.753,35.455Z",
    transform: "translate(369.259 93.639)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.17,378.572l1.059,20.123s-3.126,17.825-.555,21.672c2.552,3.827,72.621,9.521,72.621,9.521s-2.2-30.011,1.766-51.719Z",
    transform: "translate(369.082 101.643)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.862,581.089,565.89,604.7,513.027,496.585c-52.421,9.016-101.876,11.9-144.652,1-14.483-3.642-23.336-18.6-19.774-33.4q.25-1.038.578-2.054c5.119-15.62,18.52-26.672,29.079-43.851l77.121,1.171-8.614,29.721,74.918-9.695c15.066-1.95,28.826,8.956,30.733,24.357q.151,1.22.2,2.45Z",
    transform: "translate(367.437 104.013)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.315,
    cy: 31.315,
    r: 31.315,
    transform: "translate(744.051 282.164)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.569,261.362l28.713,3.378a5.859,5.859,0,0,1,5.039,4.568l4.566,20.9,28.465,33.521s10.222,19.165,6.389,40.886a153.857,153.857,0,0,1-11.872,37.861s-70,28.63-72.558,24.8-3.385-21.244-3.385-21.244L364.921,305.83a35.95,35.95,0,0,1,10.332-28.887c2.272-2.235,4.515-3.8,6.34-3.8C385.716,273,385.188,263.724,388.569,261.362Z",
    transform: "translate(368.438 94.739)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.663,666.442l-27.374-10.393,37.571-112.843c-51.042-14.965-89.543-39.07-123.16-67.682-11.4-9.642-19.957-22.024-10.244-33.753q.681-.823,1.422-1.591c11.469-11.775,40.576-9.509,57.616-20.292L456.6,460.574l-2.388,10.9,71.543,24.252c14.388,4.877,21.947,20.724,16.884,35.394q-.4,1.162-.9,2.287Z",
    transform: "translate(367.875 104.109)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.473,499.961a14.663,14.663,0,0,1-2.684-22.323L355.735,369.117l26.941,2.709,41.706,105.781a14.742,14.742,0,0,1-18.909,22.354Z",
    transform: "translate(367.905 101.108)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.178,283.91s-13.14-13.376-29.875.068-27.291,79.5-29.311,90.1,38.362,69.244,38.362,69.244l29.046,5.537-22.92-65.59Z",
    transform: "translate(367.443 95.721)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.377,223.726H569.469a9.541,9.541,0,0,0-9.526,9.526v198.33a9.535,9.535,0,0,0,9.526,9.526H863.377a9.535,9.535,0,0,0,9.526-9.526V233.252a9.541,9.541,0,0,0-9.526-9.526Z",
    transform: "translate(379.975 92.514)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.539,230.223h-289a5.105,5.105,0,0,0-5.094,5.1V428.742a5.1,5.1,0,0,0,5.094,5.094h289a5.1,5.1,0,0,0,5.094-5.094V235.327a5.105,5.105,0,0,0-5.094-5.1Z",
    transform: "translate(380.359 92.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.748,502.845H628.81a3.163,3.163,0,0,1-3.1-3.814l2.668-12.671a3.176,3.176,0,0,1,3.095-2.511h166.6a3.177,3.177,0,0,1,3.095,2.511l2.668,12.671a3.163,3.163,0,0,1-3.1,3.814Z",
    transform: "translate(383.858 107.889)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1016.557 594.019)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1027.148 594.019)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1037.739 594.019)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1048.33 594.019)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1058.921 594.019)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1069.512 594.019)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1080.103 594.019)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1090.694 594.019)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1101.285 594.019)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1111.876 594.019)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1122.467 594.019)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1133.058 594.019)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1143.65 594.019)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1154.241 594.019)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1164.832 594.019)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1175.423 594.019)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1016.432 599.315)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1027.023 599.315)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1037.614 599.315)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1048.205 599.315)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1058.796 599.315)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1069.387 599.315)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1079.978 599.315)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1090.569 599.315)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1101.16 599.315)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1111.751 599.315)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1122.342 599.315)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1132.933 599.315)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1143.524 599.315)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1154.115 599.315)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1164.707 599.315)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.296,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1175.298 599.315)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.364,
    height: 3.177,
    rx: 0.488,
    transform: "translate(1067.269 605.67)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.814,747.476l-793.453.326c-1.892,0-3.426-.565-3.426-1.261s1.534-1.261,3.426-1.261l793.453-.325c1.892,0,3.426.565,3.426,1.261s-1.534,1.261-3.426,1.261Z",
    transform: "translate(-144.935 123.322)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.137,235.327V428.742a5.1,5.1,0,0,1-5.094,5.094H750.136a125.056,125.056,0,0,1-27.283-36.709q-.667-1.334-1.271-2.7a123.948,123.948,0,0,1-11.015-42.4c-.074-.9-.138-1.8-.18-2.711-.138-2.33-.2-4.692-.2-7.064a124.483,124.483,0,0,1,8.78-46.082c.35-.911.72-1.811,1.1-2.711a125.4,125.4,0,0,1,59.681-63.239h72.295a5.105,5.105,0,0,1,5.094,5.1Z",
    transform: "translate(388.855 92.898)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.561,255.5H575.146a1.075,1.075,0,1,1,0-2.151H845.561a1.075,1.075,0,1,1,0,2.151Z",
    transform: "translate(380.81 94.265)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.302,
    cy: 6.443,
    rx: 6.302,
    ry: 6.443,
    transform: "translate(968.062 329.243)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.302,
    cy: 6.443,
    rx: 6.302,
    ry: 6.443,
    transform: "translate(989.833 329.243)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.302,
    cy: 6.443,
    rx: 6.302,
    ry: 6.443,
    transform: "translate(1011.604 329.243)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.962,237.51H803.5a1.171,1.171,0,1,0,0,2.342h15.465a1.171,1.171,0,1,0,0-2.342Z",
    transform: "translate(394.301 93.329)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.962,241.66H803.5a1.171,1.171,0,1,0,0,2.342h15.465a1.171,1.171,0,1,0,0-2.342Z",
    transform: "translate(394.301 93.574)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.962,245.805H803.5a1.171,1.171,0,1,0,0,2.342h15.465a1.171,1.171,0,1,0,0-2.342Z",
    transform: "translate(394.301 93.819)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.981,
    height: 9.191,
    rx: 4.339,
    transform: "translate(998.356 412.592)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 86.637,
    height: 9.191,
    rx: 4.339,
    transform: "translate(976.528 430.975)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 86.637,
    height: 9.191,
    rx: 4.339,
    transform: "translate(976.528 449.356)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.24,413.776a31.577,31.577,0,0,1-1.991,11.089H571.541a5.1,5.1,0,0,1-5.094-5.094V382.405a31.388,31.388,0,0,1,5.02-.4,31.772,31.772,0,0,1,31.773,31.775Z",
    transform: "translate(380.359 101.869)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.391,294.4v-2.711H811.945V260.263h-2.7v31.424H757.157V260.263h-2.7v31.424h-34.4c-.381.9-.752,1.8-1.1,2.711h35.5v53.146h-44.08c.042.911.106,1.811.18,2.711h43.9v42.4H721.571q.6,1.366,1.271,2.7h31.614v35.639h2.7V395.352h52.087v35.639h2.7V395.352h45.446v-2.7H811.945v-42.4h45.446v-2.711H811.945V294.4Zm-48.147,98.253H757.157v-42.4h52.087Zm0-45.107H757.157V294.4h52.087Z",
    transform: "translate(388.867 94.674)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.413,409.21a2.83,2.83,0,0,1-2.051-4.906l.194-.771-.077-.185a7.6,7.6,0,0,0-14.02.052c-2.293,5.523-5.212,11.055-5.931,16.894a22.483,22.483,0,0,0,.395,7.733,90.147,90.147,0,0,1-8.2-37.441,87.018,87.018,0,0,1,.54-9.707q.447-3.963,1.241-7.87a91.192,91.192,0,0,1,18.084-38.649,24.269,24.269,0,0,0,10.093-10.472,18.511,18.511,0,0,0,1.684-5.059c-.491.064-.991.1-1.482.137l-.467.024-.058,0a2.8,2.8,0,0,1-2.3-4.568l.637-.783c.322-.4.653-.8.975-1.2a1.415,1.415,0,0,0,.1-.121c.371-.459.741-.91,1.112-1.369a8.109,8.109,0,0,0-2.658-2.57c-3.714-2.175-8.837-.669-11.519,2.69s-3.2,8.071-2.264,12.268a32.494,32.494,0,0,0,4.495,10.021c-.2.258-.411.507-.612.765a91.776,91.776,0,0,0-9.58,15.176,38.153,38.153,0,0,0-2.278-17.722c-2.18-5.26-6.267-9.689-9.866-14.236-4.323-5.462-13.187-3.078-13.948,3.845q-.011.1-.022.2.8.452,1.57.96a3.839,3.839,0,0,1-1.548,6.986l-.078.012a38.2,38.2,0,0,0,1.007,5.711,39.329,39.329,0,0,0,19.582,24.649c.314.161.62.322.934.475a93.677,93.677,0,0,0-5.043,23.731,88.856,88.856,0,0,0,.065,14.346l-.024-.169a23.48,23.48,0,0,0-8.015-13.557c-6.168-5.067-14.882-6.933-21.536-11.005a4.406,4.406,0,0,0-6.749,4.287q.013.089.027.178a25.787,25.787,0,0,1,2.892,1.394q.8.452,1.57.96a3.839,3.839,0,0,1-1.548,6.986l-.078.012-.161.024a38.229,38.229,0,0,0,7.032,11.011,39.364,39.364,0,0,0,28.548,12.526h.008a93.661,93.661,0,0,0,6.291,18.366H817.85c.081-.25.153-.508.226-.757a25.531,25.531,0,0,1-6.219-.37c1.667-2.046,3.335-4.108,5-6.154a1.412,1.412,0,0,0,.1-.121c.846-1.047,1.7-2.086,2.545-3.133h0a37.4,37.4,0,0,0-1.1-9.528Zm-25.736-50.627.012-.016-.012.032ZM787.7,403.459l-.193-.435c.008-.314.008-.628,0-.951,0-.089-.016-.177-.016-.266.073.556.137,1.112.218,1.667Z",
    transform: "translate(391.253 97.458)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,18.1.307,15.66,7.359,0l23.3,6.96L26.37,28.536Z",
    transform: "translate(754.699 340.079) rotate(-13)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.938,40.034c-2.209-10.805-3.268-16.34-11.3-23.984-1.905.27.5,10.15-10,23.913-15.268,20.007-13.746,1.663-18.261,7.826-.98,1.338-1.192,6.165-.87,7.826,1.273,6.562,8.8.155.87,22.609-1.181,1.746-2.572,1.322-4.348,1.3-.137,0,.763-.173-2.609-.87-1.609-.332-3.862-.725-6.562-1.18-31.37-5.285-42.447-44.867-18.2-65.46,5.517-4.685,10.931-8.236,15.632-9.882C439.452-2.819,471.709.4,477.9,16.485a49.257,49.257,0,0,1,3.035,23.549Z",
    transform: "translate(325.42 271.193)",
    fill: "#090814",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.373,
    cy: 22.373,
    rx: 22.373,
    ry: 22.373,
    transform: "translate(719.375 330.018)",
    fill: "#090814",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.364,231.431a12.537,12.537,0,0,0,0-25.075v1.673a10.855,10.855,0,1,1-4.274.873l-.659-1.538a12.539,12.539,0,0,0,4.932,24.067Z",
    transform: "translate(205.005 115.346)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.736,59.684S-3.239,61.9.643,48.592L8.408,21.969S-1.575-5.209,13.955.893,39.468,44.71,39.468,44.71s6.656,28.842,0,28.842-27.733,4.432-25.513,0S11.736,59.684,11.736,59.684Z",
    transform: "translate(854.703 840.154) rotate(158)",
    fill: "#090814"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWebDesign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/web-design.369d80c1d3c65a9e92c5a7c028a58377.svg";